module.exports = "/_next/static/images/happy-line-cd182cc32253c2fe057c9f0eb565b31a.svg";